<template>
  <div class="row-history">
    <component
      :is="report"
      :selectItem="selectItem"
      :depthReport="depthReport"
      :pulpReport="pulpReport"
      :partcurrent="partcurrent"
      :downspeed="downspeed"
      :upspeed="upspeed"
      :ashReport="ashReport"
      :checkedData="checkedData"
    ></component>
    <a id="simulation" href=""></a>
    <el-container class="row-con">
      <el-header class="m-filter">
        <div class="wp">
          <div class="filter">
            <el-form ref="filter" class="m-filterbox">
              <div class="right">
                <el-button
                  @click="querychxun"
                  class="btn btn-search"
                  type="primary"
                  icon="el-icon-search"
                  >查询
                </el-button>
                <el-button
                  class="btn btn-reset"
                  native-type="reset"
                  @click="resetClick"
                >
                  <span class="icon icon-reset"></span><span>重置</span>
                </el-button>
                <!-- <el-button type="primary" @click="showData()">选择参数</el-button> -->
              </div>
              <div class="left">
                <el-form-item class="item g-date">
                  <el-col :span="14" class="date">
                    <el-date-picker
                      value-format="timestamp"
                      type="datetime"
                      prefix-icon=""
                      v-model="startDate"
                      placeholder="选择日期"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>

                <div class="item">至</div>

                <el-form-item class="item g-date">
                  <el-col :span="14" class="date">
                    <el-date-picker
                      value-format="timestamp"
                      type="datetime"
                      prefix-icon=""
                      v-model="endDate"
                      placeholder="选择日期"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>

                <el-form-item class="item picker picker-device">
                  <el-select v-model="deviceKey" placeholder="请选择设备">
                    <el-option
                      v-for="item in deviceList"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="item input">
                  <el-input
                    class="input"
                    placeholder="请输入桩号"
                    v-model="number"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </el-header>
      <el-main class="m-table-main">
        <div id="table-content">
          <el-table
            :data="tableData"
            style="width: 100%"
            ref="table"
            row-key="id"
            @selection-change="selectionChange"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column
              type="selection"
              align="center"
              fixed
            ></el-table-column>
            <el-table-column
              v-for="(col, index) in cols"
              :key="index"
              :prop="col.prop"
              :label="col.label"
              :formatter="col.formatter"
              min-width="148px"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column fixed="right" v-if="showDetail">
              <template slot-scope="scope">
                <div class="m-edit-btns">
                  <div class="item">
                    <a
                      href="javascript:"
                      class="btn"
                      @click="handleCommand(scope.$index)"
                      >详情</a
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <el-dialog
        title="选择需要展示的参数"
        :visible.sync="dialogFormVisible"
        width="40%"
        center
        top="15vh"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="checkedFileds"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            v-for="item in fieldNames"
            :label="item.prop"
            :key="item.prop"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="medium"
            >取 消</el-button
          >
          <el-button type="primary" @click="confirmShow" size="medium"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-container>
    <!-- 弹出框 -->
    <el-dialog :visible.sync="centerDialogVisible" class="m-pop m-pop-detail">
      <div slot="title" class="dialog-header">
        <div class="left">
          <gTabs @change="changeHandle" :current="tab2" :list="tab2List" />
        </div>
        <div class="right">
          <el-button
            v-if="showbtn"
            type="primary"
            size="small"
            @click="echartDownload"
            >图片下载</el-button
          >
        </div>
        <!-- <div class="right">
          <el-dropdown placement="top-start" @command="downLoad">
            <span class="more ">报表下载
            </span>
            <el-dropdown-menu class="g-dropdown">
              <el-dropdown-item :command="0">
                <span class="icon icon01"></span>
                <span class="name">打印版</span>
              </el-dropdown-item>
              <el-dropdown-item :command="1">
                <span class="icon icon02"></span>
                <span class="name">综合版</span>
              </el-dropdown-item>
              <el-dropdown-item :command="2">
                <span class="icon icon03"></span>
                <span class="name">详细版</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
      </div>
      <div class="dialog-content">
        <div class="m-tab-table m-tab-detail" v-show="tab2 === 0">
          <div class="m-table-detail">
            <!-- 详细数据 -->
            <div class="detailitem">
              <h3>详细数据</h3>
              <div class="box">
                <ul class="ul-detail">
                  <li class="s1">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">桩号</div>
                        <div
                          class="value"
                          :title="this.selectItem.pileDescribe"
                        >
                          {{ selectItem.pileDescribe }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">开始时间</div>
                        <div class="value">
                          {{ selectItem.beginTime | datafilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">结束时间</div>
                        <div class="value">
                          {{ selectItem.endTime | datafilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">桩端电流</div>
                        <div class="value">
                          {{ selectItem.current | numfilters }}{{ "\xa0" }}A
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">最大斜度</div>
                        <div class="value">
                          {{ selectItem.xAngle | numfilters }}{{ "\xa0" }}%
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="s2">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">桩机编号</div>
                        <div class="value">{{ selectItem.deviceKey }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">施工桩长</div>
                        <div class="value">
                          {{ selectItem.depth | numfilters }}{{ "\xa0" }}m
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">有效桩长</div>
                        <div class="value">
                          {{ selectItem | depthfilters }}{{ "\xa0" }}m
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">累计灰量</div>
                        <div class="value">
                          {{ selectItem.ash | numfilters }}{{ "\xa0" }}kg
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">平均灰量</div>
                        <div class="value">
                          {{ selectItem | averageAshFilter }}{{ "\xa0" }}kg/m
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="s3">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">成桩时间</div>
                        <div class="value">
                          {{ selectItem | minfilters }}{{ "\xa0" }}min
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">空搅深度</div>
                        <div class="value">
                          {{ selectItem.emptyDepth | numfilters }}{{ "\xa0" }}m
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">下钻速度</div>
                        <div class="value">
                          {{ selectItem.downSpeed | numfilters
                          }}{{ "\xa0" }}cm/min
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">提钻速度</div>
                        <div class="value">
                          {{ selectItem.upSpeed | numfilters
                          }}{{ "\xa0" }}cm/min
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 段数据 -->
            <br />
            <h3>段数据列表</h3>
            <el-table
              ref="saveTable"
              class="m-table-save m_table_save_height"
              :data="selectItem.data"
              style="width: 100%; margin-top: 20px"
              height="28em"
            >
              <el-table-column
                type="index"
                label="序号"
                width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="realTime"
                label="时间"
                min-width="120px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.realTime | datafilters }}
                </template>
              </el-table-column>
              <el-table-column
                property="depth"
                label="段深度(m)"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.depth | numfilters }}
                </template>
              </el-table-column>
              <el-table-column property="ash" label="段灰量(kg)" align="center">
                <template slot-scope="scope">
                  {{ scope.row.ash | numfilters }}
                </template>
              </el-table-column>
              <el-table-column
                property="current"
                label="段电流(A)"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.current | numfilters(1) }}
                </template>
              </el-table-column>
              <el-table-column
                property="pressure"
                label="段压力(kg)"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.pressure | numfilters(1) }}
                </template>
              </el-table-column>
              <el-table-column
                property="speed"
                label="速度(cm/min)"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.speed | num3filters }}
                </template>
              </el-table-column>
              <el-table-column property="speed" label="状态" align="center">
                <template slot-scope="scope">
                  {{ scope.row.speed | num5filters }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="m-tab-table m-tab-echartTable" v-show="tab2 === 1">
          <div class="m-pop-echart">
            <el-row class="row">
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart01"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart02"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
            </el-row>
            <el-row class="row">
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart03"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart04"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="echatrs" id="echartss">
            <div
              ref="myChart06"
              :style="{ width: '100%', height: '33.33%' }"
            ></div>
            <div
              ref="myChart07"
              :style="{ width: '100%', height: '33.33%' }"
            ></div>
            <div
              ref="myChart08"
              :style="{ width: '100%', height: '33.33%' }"
            ></div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-footer class="m-selectAll">
      <!-- <div class="left">
        <div class="item">
          <el-checkbox v-model="totalChecked" class="total" @change="totalChange">全选
          </el-checkbox>
        </div>
        <div class="item">
          <div class="export" @click="exportAll">导出</div>
        </div>
      </div> -->
      <div class="right">
        <el-pagination
          class="pages"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="slot,prev, pager, next"
          :total="total"
        >
          <!-- slot部分，跳转首页 -->
          <button class="lastPage" @click="toFirstPage">
            <i class="el-icon-d-arrow-left"></i>
          </button>
        </el-pagination>
        <el-pagination
          class="pages"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="slot,sizes,jumper"
          :total="total"
        >
          <!-- slot部分，跳转首页 -->
          <button class="lastPage" @click="toLastPage">
            <i class="el-icon-d-arrow-right"></i>
          </button>
        </el-pagination>
      </div>
    </el-footer>
  </div>
</template>
<script>
import report from "../report/report.vue";
import moment from "moment";
import { historyList } from "@/api/api";
import gTabs from "@/components/gTabs";
import * as echarts from "echarts";
const allField = [
  "pileDescribe",
  "deviceKey",
  "beginTime",
  "endTime",
  "depth",
  "pileTime",
];
export default {
  components: {
    gTabs,
    report,
  },
  props: [
    "tableData",
    "device",
    "deviceList",
    "pageSize",
    "total",
    "currentPage",
    "handleSizeChange",
    "handleCurrentChange",
    "toLastPage",
    "toFirstPage",
    "pileDescribe",
  ],
  data() {
    return {
      showDetail: false,

      checkedData: [],
      depthReport: [],
      ashReport: {},
      pulpReport: {},
      upspeed: {},
      downspeed: {},
      partcurrent: {},
      report: "report",
      //excel报表数据
      totalChecked: false,
      startDate: "",
      endDate: "",
      number: "",
      deviceKey: "",
      checkAll: false, //默认全选
      checkedFileds: [
        "pileDescribe",
        "beginTime",
        "endTime",
        "depth",
        "ash",
        "current",
        "xAngle",
        "pileTime",
      ], //默认显示选中的数据
      fieldNames: [
        {
          prop: "pileDescribe",
          label: "桩号",
        },
        {
          prop: "beginTime",
          label: "开始时间",
          formatter: this.testFormatter,
        },
        {
          prop: "endTime",
          label: "结束时间",
          formatter: this.testFormatter,
        },
        {
          prop: "depth",
          label: "施工桩长(m)",
          formatter: this.numFormatter,
        },
        {
          prop: "ash",
          label: "累计灰量(kg)",
          formatter: this.numFormatter,
        },
        {
          prop: "ash",
          label: "平均灰量(kg/m)",
          formatter: this.averageAsh,
        },
        {
          prop: "current",
          label: "电流(A)",
          formatter: this.numFormatter,
        },
        {
          prop: "xAngle",
          label: "最大斜度",
          formatter: this.num1Formatter,
        },
        {
          prop: "endTime",
          label: "成桩时间(min)",
          formatter: this.minFormatter,
        },
      ], //对象数组全部的数据
      isIndeterminate: false, //默认全选
      dialogFormVisible: false,
      cols: [
        {
          prop: "pileDescribe",
          label: "桩号",
        },
        {
          prop: "beginTime",
          label: "开始时间",
          formatter: this.testFormatter,
        },
        {
          prop: "endTime",
          label: "结束时间",
          formatter: this.testFormatter,
        },
        {
          prop: "depth",
          label: "施工桩长(m)",
          formatter: this.numFormatter,
        },
        // {
        //   prop: 'depth',
        //   label: '有效桩长(m)',
        //   formatter: this.depthFormatter
        // },
        {
          prop: "ash",
          label: "累计灰量(kg)",
          formatter: this.numFormatter,
        },
        {
          prop: "ash",
          label: "平均灰量(kg/m)",
          formatter: this.averageAsh,
        },
        {
          prop: "current",
          label: "电流(A)",
          formatter: this.numFormatter,
        },
        {
          prop: "xAngle",
          label: "最大斜度",
          formatter: this.num1Formatter,
        },
        {
          prop: "endTime",
          label: "成桩时间(min)",
          formatter: this.minFormatter,
        },
      ],
      tempCols: [], //临时的数据容器
      centerDialogVisible: false, // 弹窗
      data: [],
      selectItem: [],
      tab2: 0,
      tab2List: [
        {
          name: "详细内容",
        },
        {
          name: "图表曲线",
        },
      ],
      selectTable: "记录报表下载",
      selectTableList: [
        {
          label: "记录报表下载",
          value: "0",
        },
        {
          label: "记录报表下载1",
          value: "1",
        },
      ],
      inquire: [],
      totalNum: 0,
      echartLoad: [],
      downloadechart: [],
      showbtn: false,
    };
  },
  filters: {
    datafilters(val) {
      return moment(val * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    numfilters(val, deg) {
      if (deg == undefined) {
        deg = 2;
      }
      if (isNaN(val)) {
        return val;
      } else {
        return parseFloat(val).toFixed(deg);
      }
    },
    averageAshFilter(val) {
      if (val.ash == 0 && val.depth - val.emptyDepth == 0) {
        return 0;
      } else {
        return parseFloat(val.ash / (val.depth - val.emptyDepth)).toFixed(2);
      }
    },
    minfilters(val) {
      return (parseFloat(val.endTime - val.beginTime) / 60).toFixed(0);
    },
    num1filters(val) {
      return parseFloat(val).toFixed(2) + "%";
    },
    num3filters(val) {
      return Math.abs(parseFloat(val).toFixed(2));
    },
    num5filters(val) {
      return val < 0 ? "提钻" : "下钻";
    },
    depthfilters(val) {
      return parseFloat(val.depth - val.emptyDepth).toFixed(2);
    },
  },
  watch: {
    centerDialogVisible(val, oldval) {
      if (val == false) {
        this.showbtn = false;
        this.tab2 = 0;
        this.selectItem = [];
        this.upspeed = [];
        this.downspeed = [];
        this.partcurrent = [];
        this.ashReport = [];
        this.depthReport = [];
        this.data = [];
        if (this.myChart01 == undefined || this.myChart01._disposed) return;
        this.myChart01.dispose();
        this.myChart02.dispose();
        this.myChart03.dispose();
        this.myChart04.dispose();
      }
    },
  },
  mounted() {
    if (sessionStorage["clientId"] == 39) {
      this.showDetail = true;
    } else {
      this.showDetail = false;
    }
    this.deviceKey = this.device;
  },
  methods: {
    echartDownload() {
      let a = document.createElement("a");
      a.href = this.myChart06.getConnectedDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      a.download = "图片下载.png";
      a.click();
    },
    exportAll() {
      // this.tableToExcel('FPZstatisticsTableRecord', '粉喷桩桩-导出')
    },
    downLoad(command) {
      switch (command) {
        case 0: {
          this.tableToExcel("FPZstatisticsTablePrint", "粉喷桩桩-打印版");
          break;
        }
        case 1: {
          this.tableToExcel("FPZstatisticsTable", "粉喷桩桩-综合版");
          break;
        }
        case 2: {
          this.tableToExcel("FPZstatisticsTabledetailed", "粉喷桩桩-详细版");
          break;
        }
      }
    },
    //表格导出的封装
    tableToExcel(tableid, sheetName) {
      let uri = "data:application/vnd.ms-excel;base64,";
      let template =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' +
        'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' +
        "<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>" +
        "</x:ExcelWorkbook></xml><![endif]-->" +
        ' <style type="text/css">' +
        "table td {" +
        "height: 25px;" +
        "font-family: 宋体;" +
        "font-size: 13px;" +
        "text-align: left;" +
        "border: 0.5px solid #000000;" +
        " }" +
        "table .tHead {" +
        "font-size: 20px;" +
        "text-align:center;" +
        "font-weight: bold;" +
        "height: 40px;" +
        " }" +
        "table tfoot tr{" +
        "height: 25px;" +
        " }" +
        "table tbody td{" +
        "text-align: center;" +
        "height: 20px;" +
        " }" +
        "</style>" +
        '</head><body ><table class="excelTable">{table}</table></body></html>';
      if (!tableid.nodeType) tableid = document.getElementById(tableid);
      let ctx;
      if (tableid) {
        ctx = { worksheet: sheetName || "Worksheet", table: tableid.innerHTML };
        document.getElementById("simulation").href =
          uri + this.base64(this.format(template, ctx));
        document.getElementById("simulation").download = sheetName + ".xls"; //自定义文件名
        document.getElementById("simulation").click();
      }
    },
    base64(s) {
      return window.btoa(unescape(encodeURIComponent(s)));
    },
    format(s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p];
      });
    },

    querychxun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      historyList(
        "ZKFPZ",
        0,
        this.deviceKey,
        this.pageSize,
        this.number,
        this.startDate,
        this.endDate
      ).then((res) => {
        // this.tableData = res.content;
        // this.total = res.totalElements;
        this.inquire = res.content;
        this.totalNum = res.totalElements;
        this.$emit(
          "changeDevicekey",
          this.deviceKey,
          this.number,
          this.startDate,
          this.endDate,
          this.inquire,
          this.totalNum
        );
        loading.close();
      });

      setTimeout(() => {
        loading.close();
      }, 6000);
    },

    resetClick() {
      this.deviceKey = "";
      (this.number = ""), (this.startDate = ""), (this.endDate = "");
    },

    testFormatter(row, column, cellValue, index) {
      return moment(cellValue * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    numFormatter(row, column, cellValue, index) {
      return parseFloat(cellValue).toFixed(2);
    },
    num11Formatter(row, column, cellValue, index) {
      return parseFloat(cellValue).toFixed(1);
    },
    minFormatter(row, column, cellValue, index) {
      return (parseFloat(cellValue - row.beginTime) / 60).toFixed(0);
    },
    num1Formatter(row, column, cellValue, index) {
      return parseFloat(cellValue).toFixed(1) + "%";
    },
    averageAsh(row, column, cellValue, index) {
      if (row.depth == 0 && cellValue == 0) {
        return 0;
      } else {
        return parseFloat(cellValue / (row.depth - row.emptyDepth)).toFixed(2);
      }
    },
    // depthFormatter(row, column, cellavlue, index) {
    //   return parseFloat(cellavlue - row.emptyDepth).toFixed(2)
    // },

    //全选按钮
    handleCheckAllChange(val) {
      this.checkedFileds = val ? allField : [];
      this.isIndeterminate = false;
    },
    //单个选中
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.fieldNames.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.fieldNames.length;
    },
    showData(row) {
      this.dialogFormVisible = true;
    },
    confirmShow() {
      this.tempCols = [];
      if (this.checkedFileds.length < 1) {
        this.$message.warning("请至少选择一项数据");
        this.dialogFormVisible = true;
      } else {
        for (var i = 0; i < this.fieldNames.length; i++) {
          for (var j = 0; j < this.checkedFileds.length; j++) {
            if (this.fieldNames[i].prop == this.checkedFileds[j]) {
              this.tempCols.push(this.fieldNames[i]);
            }
          }
        }
        this.cols = this.tempCols;
        this.dialogFormVisible = false;
      }
    },
    initEchart01() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.depth];
      });
      let option = {
        title: {
          text: "深度曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度",
            type: "value",
            inverse: true,
            nameLocation: "end",
            max: 30,
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart01 = echarts.init(this.$refs.myChart01, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart01.setOption(option);
      this.echartLoad.push(this.myChart01);
    },
    initEchart02() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.depth.toFixed(2)];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.current.toFixed(2)];
      });
      let option = {
        title: {
          text: "深度、电流曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "电流"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度",
            type: "value",
            inverse: true, //设置坐标轴翻转
            nameLocation: "end",
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
            max: 30,
          },
          {
            name: "电流",
            type: "value",
            nameLocation: "start",
            max: 300,
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "电流",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart02 = echarts.init(this.$refs.myChart02, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart02.setOption(option);
      this.echartLoad.push(this.myChart02);
    },
    initEchart03() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.ash.toFixed(2)];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.speed.toFixed(2)];
      });
      let option = {
        title: {
          text: "段灰量、速度变化曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["段灰量", "速度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "段灰量(kg)",
            type: "value",
            nameLocation: "start",
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 20],
            },
          },
          {
            name: "速度(cm/min) ",
            type: "value",
            nameLocation: "start",
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              padding: [10, 25, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "段灰量",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "速度",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart03 = echarts.init(this.$refs.myChart03, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart03.setOption(option);
      this.echartLoad.push(this.myChart03);
    },
    initEchart04() {
      var ash = [];
      for (var j = 0; j < this.selectItem.data.length; j++) {
        if (ash[Math.ceil(this.selectItem.data[j].depth - 1)] == undefined) {
          ash[Math.ceil(this.selectItem.data[j].depth - 1)] = 0;
        }
        ash[Math.ceil(this.selectItem.data[j].depth - 1)] +=
          this.selectItem.data[j].ash;
      }
      var numbers2 = ash.map(myFunction);
      function myFunction(value, index, array) {
        var data = {
          value: Number(value.toFixed(2)),
          name: index + 1,
        };
        return data;
      }
      let option = {
        title: {
          text: "成桩灰量分布",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} : {c}",
        },
        grid: {
          top: "10%",
          bottom: "10%",
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "成桩灰量分布",
            type: "funnel",
            width: "50%",
            left: "center",
            top: "15%",
            bottom: "8%",
            label: {
              show: true,
            },
            labelLine: {
              show: true,
            },
            data: numbers2,
            sort: "none",
            color: "#5470c6",
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart04 = echarts.init(this.$refs.myChart04, null, {
        renderer: "svg",
      });
      // 绘制图表
      this.myChart04.setOption(option);
    },

    initEchart06() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.depth];
      });
      let option = {
        title: {
          text: "深度曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度          ",
            type: "value",
            inverse: true,
            nameLocation: "end",
            max: 30,
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart06 = echarts.init(this.$refs.myChart06, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart06.setOption(option);
      this.downloadechart.push(this.myChart06);
    },
    initEchart07() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.depth.toFixed(2)];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.current.toFixed(2)];
      });
      let option = {
        title: {
          text: "深度、电流曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "电流"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度          ",
            type: "value",
            inverse: true, //设置坐标轴翻转
            nameLocation: "end",
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
            max: 30,
          },
          {
            name: "          电流",
            type: "value",
            nameLocation: "start",
            max: 300,
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "电流",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart07 = echarts.init(this.$refs.myChart07, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart07.setOption(option);
      this.downloadechart.push(this.myChart07);
    },
    initEchart08() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.ash.toFixed(2)];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.speed.toFixed(2)];
      });
      let option = {
        title: {
          text: "段灰量、速度变化曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["段灰量", "速度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "段灰量(kg)",
            type: "value",
            nameLocation: "start",
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
          {
            name: "速度(cm/min)      ",
            type: "value",
            nameLocation: "start",
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "段灰量",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "速度",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart08 = echarts.init(this.$refs.myChart08, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart08.setOption(option);
      this.downloadechart.push(this.myChart08);
    },
    changeHandle(index) {
      let self = this;
      this.tab2 = index;
      if (index == 0) {
        this.showbtn = false;
      }
      if (index === 1) {
        this.showbtn = true;
        this.$nextTick(() => {
          this.initEchart01();
          this.initEchart02();
          this.initEchart03();
          this.initEchart04();
          echarts.connect(this.echartLoad);
          this.initEchart06();
          this.initEchart07();
          this.initEchart08();
          echarts.connect(this.downloadechart);
          window.onresize = function () {
            self.myChart01.resize();
            self.myChart02.resize();
            self.myChart03.resize();
            self.myChart04.resize();
          };
        });
      }
    },
    // 点击详情
    handleCommand(index) {
      this.selectItem = this.tableData[index];
      this.centerDialogVisible = true; // 显示弹出框
      var time;
      for (var i = 0; i < this.tableData[index].data.length; i++) {
        time = moment(this.tableData[index].data[i].realTime * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.data.push(time);
      }
    },
    // 选中发生变化
    selectionChange(e) {
      if (e.length == this.tableData.length) {
        this.totalChecked = true;
      } else if (this.totalChecked) {
        this.totalChecked = false;
      }
    },
    totalChange(e) {
      if (!e) {
        this.$refs.table.clearSelection();
      } else {
        this.$refs.table.clearSelection();
        this.$refs.table.toggleAllSelection();
      }
    },
  },
};
</script>
<style scoped>
.m-tab-echartTable {
  position: relative;
}
.echatrs {
  position: absolute;
  top: 0;
  left: -2000px;
  width: 800px;
  height: 660px;
}

.ul-detail li {
  width: 33%;
}
.el-checkbox {
  width: 20%;
}
.el-button--primary {
  margin-left: 25px;
  margin-right: 5px;
}

.el-table thead {
  color: #333;
}

/* 修改字体 */
.cell {
  font-size: 14px;
}
/* 历史记录 详情 详细数据下的padding值 */
.ul-detail li {
  padding: 0 1.3rem 0 0;
}
.ul-detail li:first-child {
  padding-left: 1.3rem;
}
</style>

